module.exports = __webpack_public_path__ + "213d59e24d7fcddbeb28d1b16aa5f4f2.png";